import OrganizationSuspended from './OrganizationSuspended';
export default OrganizationSuspended;
